// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DisconnectOutlinedSvg from "@ant-design/icons-svg/es/asn/DisconnectOutlined";
import AntdIcon from '../components/AntdIcon';

var DisconnectOutlined = function DisconnectOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DisconnectOutlinedSvg
  }));
};

DisconnectOutlined.displayName = 'DisconnectOutlined';
export default React.forwardRef(DisconnectOutlined);